import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";

export const Section1 = () => {
  const isMobile = useResponsiveMobile(900);
  return (
    <div className="flex-col gap-6  md:flex px-4 md:max-w-[1600px] md:self-center">
      <div className="flex flex-col gap-6 justify-center items-center">
        <span className="font-normal text-[#0079FF] text-[18px]">품 도입효과</span>
        <div className="flex flex-col gap-6">
          <h1 className="font-bold text-[36px] md:text-display text-center">
            정산 최적화를 통한 <br /> 비즈니스 정산 {isMobile && <br />} 업무 극대화
          </h1>
          <span className="text-center text-[18px] md:text-heading1 font-normal text-[#4D4F58]">
            수억 원의 구축비와 유지보수 부담을 없애고,
            <br /> 매출 규모에 맞춘 가변적 구독 모델로 {isMobile && <br />}운영 리스크를
            최소화하세요. {isMobile && <br />}
            <br />
            불확실한 시스템 투자 대신,{isMobile && <br />} 합리적인 비용으로 {isMobile && <br />}
            검증된 정산 체계를 즉시 확보할 수 있습니다.
          </span>
        </div>
      </div>
    </div>
  );
};
